export const invertKeyValues = (obj) => {
    const newObj = {}
    Object.keys ( obj ). forEach ( ((x) => { newObj[obj[x]] = x }))

    return newObj
}

export function isEquivalent(a, b) {
    // Create arrays of property names
    var aProps = Object.getOwnPropertyNames(a)
    var bProps = Object.getOwnPropertyNames(b)

    // If number of properties is different,
    // objects are not equivalent
    if (aProps.length != bProps.length) {
        return false
    }

    for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i]

        // If values of same property are not equal,
        // objects are not equivalent
        if (a[propName] !== b[propName]) {
            return false
        }
    }

    // If we made it this far, objects
    // are considered equivalent
    return true
}

export const getkeyByValue = (obj, value) => {
    if(typeof value === 'object') {
        return Object.keys(obj).find(key => {
            return isEquivalent(obj[key], value)
        })
    }

    return Object.keys(obj).find(key => {
        return obj[key] === value
    })
}

export const filterObject = (obj, predicate) => {
    return Object.keys(obj)
        .filter( key => predicate(obj[key]) )
        .reduce( (res, key) => (res[key] = obj[key], res), {} )
}

export const firstIndex = (obj) => {
    const firstIndex = Object.keys(obj)[0]

    return obj[firstIndex] || undefined
}

export function isObject(value) {
    return value !== null && typeof value === 'object'
}

export function objectExtend(a, b) {
    // Don't touch 'null' or 'undefined' objects.
    if (a == null || b == null) {
        return a
    }

    Object.keys(b).forEach(function (key) {
        if (Object.prototype.toString.call(b[key]) == '[object Object]') {
            if (Object.prototype.toString.call(a[key]) != '[object Object]') {
                a[key] = b[key]
            } else {
                a[key] = objectExtend(a[key], b[key])
            }
        } else {
            a[key] = b[key]
        }
    })

    return a
}